import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    CreatePackageForMajorServiceCentroRequestBody,
    GetBusInfoDetailByCompanyRequestBody,
    GetBusInfoDetailByCompanyResponseData,
    GetListPackageByMajorServiceIdRequestBody,
    PackageWorkflowServiceModel,
    ServiceManagementPackageInfoModel,
    UpdatePackageForMajorServiceCentroRequestBody,
    UpdatePackageStatusForMajorServiceCentroRequestBody,
    updateSameDayBookingRequestBody,
    GetAllServiceGroupRequestBody,
    ServiceGroupQry,
    GetServiceGroupDetailRequestBody,
    SubServiceInfoDTO,
    SaveServiceGroupRequestBody,
    createPackageServiceBundleRequestBody,
    CentroCategoryInfoDetailQry,
    UpdateCentroCategoryInfoRequestBody,
    ServiceInfoModel,
    CentroCategoryInfoModel,
    CentroCategoryListRequest,
    GetServiceRequest,
    GetSubServiceRequest,
    GetSubSubServiceRequest,
    UpdateCentroCategoryStatusRequestBody,
    CentroServiceConfigQry,
    GetCentroServiceConfigRequest,
    SaveCentroServiceConfigRequestBody,
    AddCentroCategoryServiceRequestBody,
    UpdateCentroCategoryServiceRequestBody,
    CentroCategoryServiceQry,
} from '../models'
import { stat } from 'fs'
import { CatalogueNode, CataloguePayload } from '../components/catalogue-modal/catalogueModel'

interface ServiceManagementState {
    // majorServicesData: PackageWorkflowServiceModel[],
    // loadingMajorServicesData: boolean
}

const initialState: ServiceManagementState = {
    // majorServicesData: [],
    // loadingMajorServicesData: false
}

const serviceManagementSlice = createSlice({
    name: 'ServiceManagementSlice',
    initialState,
    reducers: {
        getListPackageWorkflowService(
            state,
            action: PayloadAction<{
                callback: (res: PackageWorkflowServiceModel[] | null, err: any) => void
            }>
        ) {
            // state.loadingMajorServicesData = true
        },
        createPackageWorkflowService(
            state,
            action: PayloadAction<{ callback: (res: boolean | null, err: any) => void; body: FormData }>
        ) { },
        updatePackageWorkflowService(
            state,
            action: PayloadAction<{ callback: (res: boolean | null, err: any) => void; body: FormData }>
        ) { },
        updateSameDayBooking(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: updateSameDayBookingRequestBody
            }>
        ) { },
        getBusInfoDetailByCompany(
            state,
            action: PayloadAction<{
                callback: (res: GetBusInfoDetailByCompanyResponseData | null, err: any) => void
                body: GetBusInfoDetailByCompanyRequestBody
            }>
        ) { },
        getListPackageByMajorServiceId(
            state,
            action: PayloadAction<{
                callback: (res: ServiceManagementPackageInfoModel[] | null, err: any) => void
                body: GetListPackageByMajorServiceIdRequestBody
            }>
        ) { },
        createPackageForMajorServiceCentro(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: CreatePackageForMajorServiceCentroRequestBody
            }>
        ) { },
        updatePackageForMajorServiceCentro(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: UpdatePackageForMajorServiceCentroRequestBody
            }>
        ) { },
        updatePackageStatusForMajorServiceCentro(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: UpdatePackageStatusForMajorServiceCentroRequestBody
            }>
        ) { },
        getAllServiceGroup(
            state,
            action: PayloadAction<{
                callback: (res: ServiceGroupQry[] | null, err: any) => void
                serviceId: number
            }>
        ) { },
        getServiceGroupDetail(
            state,
            action: PayloadAction<{
                callback: (res: ServiceGroupQry | null, err: any) => void
                body: GetServiceGroupDetailRequestBody
            }>
        ) { },
        getServiceGroupList(
            state,
            action: PayloadAction<{
                callback: (res: ServiceGroupQry[] | null, err: any) => void
                body: { serviceId: number }
            }>
        ) { },
        getSubServiceInfo(
            state,
            action: PayloadAction<{
                callback: (res: SubServiceInfoDTO[] | null, err: any) => void
                serviceId: number
            }>
        ) { },
        saveServiceGroup(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: SaveServiceGroupRequestBody
            }>
        ) { },
        saveAllServiceGroups(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: SaveServiceGroupRequestBody[]
            }>
        ) { },
        deleteServiceGroup(
            state,
            action: PayloadAction<{ callback: (res: boolean | null, err: any) => void; id: number }>
        ) { },
        getPackageServiceInfo(
            state,
            action: PayloadAction<{ callback: (res: any[] | null, err: any) => void; data: any }>
        ) { },
        getBundleDataFromPackage(
            state,
            action: PayloadAction<{ callback: (res: any[] | null, err: any) => void; data: any }>
        ) { },

        createPackageServiceBundle(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: createPackageServiceBundleRequestBody
            }>
        ) { },

        getPackageServiceBundle(
            state,
            action: PayloadAction<{ callback: (res: any[] | null, err: any) => void; data: any }>
        ) { },
        updatePackageServiceBundle(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: createPackageServiceBundleRequestBody
            }>
        ) { },
        getCentroCategoryInfoDetail(
            state,
            action: PayloadAction<{
                callback: (res: CentroCategoryInfoDetailQry | null, err: any) => void
                id: string
            }>
        ) { },
        addCentroCategoryInfo(
            state,
            action: PayloadAction<{ callback: (res: boolean | null, err: any) => void; body: FormData }>
        ) { },
        updateCentroCategoryInfo(
            state,
            action: PayloadAction<{
                callback: (res: boolean | null, err: any) => void
                body: UpdateCentroCategoryInfoRequestBody
            }>
        ) { },
        setServiceDefault: (
            state,
            action: PayloadAction<{
                callback: (res: CatalogueNode[] | null, err: any) => void
            }>
        ) => { },
        getCategoryList(
            state,
            action: PayloadAction<{
                callback: (res: CentroCategoryInfoModel[] | null, err: any) => void
                data: CentroCategoryListRequest
            }>
        ) { },
        // Same request as getCategoryList, for the Major modal's Category dropdown
        getCategoryOptions(
            state,
            action: PayloadAction<{
                callback: (res: CentroCategoryInfoModel[] | null, err: any) => void
                data: CentroCategoryListRequest
            }>
        ) { },
        getServiceByCategoryId(
            state,
            action: PayloadAction<{
                data: GetServiceRequest
                callback: (res: CentroCategoryServiceQry[] | null, err: any) => void
            }>
        ) { },
        getSubServiceByServiceId(
            state,
            action: PayloadAction<{
                data: GetSubServiceRequest
                callback: (res: ServiceInfoModel[] | null, err: any) => void
            }>
        ) { },
        getSubSubServiceBySubServiceId(
            state,
            action: PayloadAction<{
                data: GetSubSubServiceRequest
                callback: (res: ServiceInfoModel[] | null, err: any) => void
            }>
        ) { },
        updateCentroCategoryStatus(
            state,
            action: PayloadAction<{
                data: UpdateCentroCategoryStatusRequestBody
                callback: (res: boolean | null, err: any) => void
            }>
        ) { },

        updateCentroCategoryServiceStatus(
            state,
            action: PayloadAction<{
                data: UpdateCentroCategoryStatusRequestBody
                callback: (res: boolean | null, err: any) => void
            }>
        ) { },
        getCentroServiceConfig(
            state,
            action: PayloadAction<{
                data: GetCentroServiceConfigRequest
                callback: (res: CentroServiceConfigQry | null, err: any) => void
            }>
        ) { },
        addCentroCategoryService(
            state,
            action: PayloadAction<{
                data: AddCentroCategoryServiceRequestBody
                callback: (res: string | null, err: any) => void
            }>
        ) { },
        updateCentroCategoryService(
            state,
            action: PayloadAction<{
                data: UpdateCentroCategoryServiceRequestBody
                callback: (res: boolean | null, err: any) => void
            }>
        ) { },
        saveCentroServiceConfig(
            state,
            action: PayloadAction<{
                data: SaveCentroServiceConfigRequestBody
                callback: (res: boolean | null, err: any) => void
            }>
        ) { },
        uploadCentroCategoryServiceIcon(
            state,
            action: PayloadAction<{
                data: FormData
                callback: (res: string | null, err: any) => void
            }>
        ) { },
        getB8AKCategoryList: (
            state,
            action: PayloadAction<{
                callback: (res: any[] | null, err: any) => void
            }>
        ) => { },

        getB8akCatalogue: (
            state,
            action: PayloadAction<{
                businessTypeId?: string
                callback: (res: CatalogueNode[] | null, err: any) => void
            }>
        ) => { },
        addCategory: (
            state,
            action: PayloadAction<{
                data: CataloguePayload
                callback: (res: string | null, err: any) => void
            }>
        ) => { },
    },
})

// service management
// export const selectOpeningAddOrderSourceModal = (state: RootState) => state.serviceManagement.openingAddOrderSourceModal;

// Action
export const serviceManagementAction = serviceManagementSlice.actions

// Reducer
const serviceManagementReducer = serviceManagementSlice.reducer
export default serviceManagementReducer
